<template>
  <div class="about">
    <span class="sign-enterprise-info">2016-2021 鲁ICP备18025351号 copyright ©️还有一些文字需要添加</span>
  </div>
</template>
<script>
export default {
  name: 'about',
  data() {
    return {}
  },
  created() {}
}
</script>

<style scoped lang="scss">
.about {
  position: relative;
  bottom: 0px;
  background-color: $bottom-color;
  height: $bottom-height;
  text-align: center;
  line-height: 30px;
}
.sign-enterprise-info {
  font-size: 12px;
  color: #ffffff;
}
</style>